import React, { useMemo } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import _ from 'underscore';

import { SearchBox } from '@bingads-webui-fluent-component/scope-selector-menu';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { MenuDivider, MenuGroup, MenuList } from '@fluentui/react-components';

import { getCampaignSelectorStyles } from '../styles/campaign-selector';
import { CampaignSelectorItem } from './campaign-selector-item';

export function CampaignSelector({
  i18n,
  className,
  isCampaignListLoading,
  campaignNodesList,
  allCampaignsNode,
  onSearchChange,
}) {
  const classes = useDefaultStyles(getCampaignSelectorStyles);

  const placeholderTreeNode = useMemo(
    () => (isCampaignListLoading
      ? (
        <div className={classnames('budget-center-campaign-selector-placeholder', classes.PlaceholderNode)}>
          <div className={classnames('budget-center-campaign-selector-placeholder-spinner-icon', classes.PlaceholderNodeIcon)}>
            <div className={classes.Spinner} />
          </div>
          <div className="budget-center-campaign-selector-placeholder-spinner-label">{i18n.getString(_TL_('Loading...'))}</div>
        </div>
      )
      : null)
    , [classes, i18n, isCampaignListLoading]
  );

  return (
    <MenuList className={classnames('budget-center-campaign-selector', classes.CampaignSelector, className)}>
      <MenuGroup key="menu-group-search-box">
        <div className={classnames('campaign-selector-search-box', classes.SearchBox)}>
          <SearchBox
            placeholder={i18n.getString(_TL_('Search campaign'))}
            onSearchChange={onSearchChange}
          />
        </div>
      </MenuGroup>
      <MenuDivider />
      <MenuGroup key="menu-group-campaign-items" className={classes.ListMenuGroup}>
        <CampaignSelectorItem key="all-campaign-node" {...allCampaignsNode} className="all-campaign-node" />
        {placeholderTreeNode}
        <div className={classnames('campaign-selector-scrolling-container', classes.ScrollingContainer)}>
          {_.map(campaignNodesList, campaignNode => (
            <CampaignSelectorItem key={campaignNode.name} {...campaignNode} />
          ))}
        </div>
      </MenuGroup>
    </MenuList>
  );
}

CampaignSelector.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  className: PropTypes.string,
  isCampaignListLoading: PropTypes.bool,
  campaignNodesList: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    severity: PropTypes.number,
  })),
  allCampaignsNode: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    severity: PropTypes.number.isRequired,
  }).isRequired,
  onSearchChange: PropTypes.func.isRequired,
};

CampaignSelector.defaultProps = {
  className: '',
  isCampaignListLoading: false,
  campaignNodesList: [],
};
